var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoliche(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 622 c-109 -39 -178 -112 -210 -221 -29 -102 4 -228 82 -306 122 -121 328 -121 450 0 91 92 118 241 64 356 -69 146 -241 223 -386 171z m224 -40 c54 -28 106 -80 135 -135 19 -34 23 -58 23 -127 0 -69 -4 -93 -23 -127 -28 -54 -81 -107 -135 -135 -60 -33 -194 -33 -254 0 -55 29 -107 81 -134 134 -26 51 -35 148 -20 204 23 87 98 167 188 200 54 20 167 13 220 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202 524 c-30 -21 -29 -59 3 -80 23 -15 27 -15 50 0 32 21 33 59 3 80 -12 9 -25 16 -28 16 -3 0 -16 -7 -28 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 394 c-29 -21 -27 -60 4 -80 23 -15 27 -15 50 0 27 18 32 43 13 68 -20 24 -44 28 -67 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262 388 c-28 -28 -3 -88 37 -88 10 0 26 9 36 20 27 30 10 74 -30 78 -17 2 -36 -3 -43 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoliche);
export default __webpack_public_path__ + "static/media/boliche.e9efffe5c6a1ad298036ed8fa3f09cfd.svg";
export { ForwardRef as ReactComponent };